/**
 * Extracts a user-friendly error message from an API error response.
 * Handles express-validator error arrays and generic error messages.
 */
export const extractErrorMessage = (err, fallback = 'Ha ocurrido un error inesperado') => {
  const data = err.response?.data;
  if (data?.errors?.length) {
    return data.errors.map((e) => e.msg || e.message).filter(Boolean).join('. ');
  }
  return data?.message || fallback;
};
